var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.666992L6 0.666992V2.00033L10 2.00033V0.666992ZM7.33333 9.33366H8.66667V5.33366H7.33333L7.33333 9.33366ZM12.6867 4.92699L13.6333 3.98033C13.3467 3.64033 13.0333 3.32033 12.6933 3.04033L11.7467 3.98699C10.7133 3.16033 9.41333 2.66699 8 2.66699C4.68667 2.66699 2 5.35366 2 8.66699C2 11.9803 4.68 14.667 8 14.667C11.32 14.667 14 11.9803 14 8.66699C14 7.25366 13.5067 5.95366 12.6867 4.92699ZM8 13.3337C5.42 13.3337 3.33333 11.247 3.33333 8.66699C3.33333 6.08699 5.42 4.00033 8 4.00033C10.58 4.00033 12.6667 6.08699 12.6667 8.66699C12.6667 11.247 10.58 13.3337 8 13.3337Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.86b0104f.svg";
export { ForwardRef as ReactComponent };